var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[(_vm.token && _vm.$route.path.split('/')[1] == 'patient')?_c('NavbarRM'):(
      _vm.token &&
      (_vm.$route.path.split('/')[1] == 'master' ||
        _vm.$route.path.split('/')[1] == 'stock' ||
        _vm.$route.path.split('/')[1] == 'pos' ||
        _vm.$route.path.split('/')[1] == 'report' ||
        _vm.$route.path.split('/')[1] == 'log-aktifitas' ||
        (_vm.$route.path.split('/')[1] == 'dashboard' &&
          _vm.$route.path.split('/')[2] == 'pos'))
    )?_c('NavbarPOS'):(
      _vm.token &&
      (_vm.$route.path.split('/')[1] == 'content' ||
        _vm.$route.path.split('/')[1] == 'consultant' ||
        _vm.$route.path.split('/')[1] == 'partner' ||
        _vm.$route.path.split('/')[1] == 'setting' ||
        (_vm.$route.path.split('/')[1] == 'dashboard' &&
          _vm.$route.path.split('/')[2] == 'general'))
    )?_c('NavbarPortal'):(
      _vm.token &&
      (_vm.$route.path.split('/')[1] == 'kelas')
    )?_c('NavbarELearning'):(
      _vm.token &&
      (_vm.$route.path.split('/')[1] == 'e-commerce')
    )?_c('NavbarEcommerce'):(
      _vm.token &&
      (_vm.$route.path.split('/')[1] == 'ake')
    )?_c('NavbarAke'):(_vm.token && _vm.$route.path != '/' && _vm.$route.path != '/404')?_c('Navbar'):_vm._e(),_c('v-main',{class:_vm.$route.path.split('/')[1] === 'patient' ? 'font-rekam' : '',attrs:{"min-height":"80%","light":""}},[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }